export const CONTACT_FIELD_LABELS = {
    email: "E-Mail",
    phone: "Telefon",
};

export const EMAIL_REQUIRED_MESSAGE = "Bitte E-Mail eingeben.";
export const EMAIL_INVALID_MESSAGE = "Bitte gültige E-Mail-Adresse eingeben.";
export const PHONE_REQUIRED_MESSAGE = "Bitte Telefon eingeben.";
export const PHONE_INVALID_MESSAGE = "Bitte gültige Telefonnummer eingeben.";

const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const PHONE_REGEX = /^\+?[0-9\s()./-]+$/;

export const getEmailError = (value, { required = false } = {}) => {
    const trimmed = (value || "").trim();
    if (!trimmed) {
        return required ? EMAIL_REQUIRED_MESSAGE : "";
    }
    return EMAIL_REGEX.test(trimmed) ? "" : EMAIL_INVALID_MESSAGE;
};

export const getPhoneError = (value, { required = false } = {}) => {
    const trimmed = (value || "").trim();
    if (!trimmed) {
        return required ? PHONE_REQUIRED_MESSAGE : "";
    }
    const digits = trimmed.replace(/[^0-9]/g, "");
    if (digits.length < 5) {
        return PHONE_INVALID_MESSAGE;
    }
    return PHONE_REGEX.test(trimmed) ? "" : PHONE_INVALID_MESSAGE;
};
